// Feature 030 - Credential Expiration Alerts.
// Computes an OK / Expiring soon / Expired / No expiry status from a credential's
// ExpirationDate. There is no platform-exposed computed status field (see FR020 gap
// analysis), so this mirrors the platform's configurable EXPIRATION_DATE_NOTIFY_PERIOD
// concept entirely client-side.

// Days before ExpirationDate at which a credential is flagged "Expiring soon".
export const EXPIRATION_ALERT_WINDOW_DAYS = 30;

export const EXPIRATION_STATUS = {
  NO_EXPIRY: 'No expiry',
  EXPIRED: 'Expired',
  EXPIRING_SOON: 'Expiring soon',
  OK: 'OK',
};

export const getExpirationInfo = (expirationDate) => {
  const expiry = expirationDate ? new Date(expirationDate) : null;
  if (!expiry || Number.isNaN(expiry.getTime())) {
    return { status: EXPIRATION_STATUS.NO_EXPIRY, daysUntilExpiry: null };
  }
  const msPerDay = 24 * 60 * 60 * 1000;
  const daysUntilExpiry = Math.ceil((expiry.getTime() - Date.now()) / msPerDay);
  if (daysUntilExpiry < 0) return { status: EXPIRATION_STATUS.EXPIRED, daysUntilExpiry };
  if (daysUntilExpiry <= EXPIRATION_ALERT_WINDOW_DAYS) return { status: EXPIRATION_STATUS.EXPIRING_SOON, daysUntilExpiry };
  return { status: EXPIRATION_STATUS.OK, daysUntilExpiry };
};

export const getExpirationPillStyle = (status) => {
  switch (status) {
    case EXPIRATION_STATUS.EXPIRED:
      return 'px-3 py-1 text-sm font-medium rounded-full inline-block border bg-red-100 text-red-700 border-red-400';
    case EXPIRATION_STATUS.EXPIRING_SOON:
      return 'px-3 py-1 text-sm font-medium rounded-full inline-block border bg-yellow-100 text-yellow-700 border-yellow-400';
    case EXPIRATION_STATUS.OK:
      return 'px-3 py-1 text-sm font-medium rounded-full inline-block border bg-green-100 text-green-700 border-green-400';
    default:
      return 'px-3 py-1 text-sm font-medium rounded-full inline-block border bg-gray-100 text-gray-600 border-gray-300';
  }
};
